import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { validateVenue } from "sweet-global";
import BackButton from "sweet-web/components/universal/Button/BackButton";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import CheckboxInput from "sweet-web/components/universal/Input/CheckboxInput";
import PhoneNumberInput from "sweet-web/components/universal/Input/PhoneNumberInput";
import { Label, SectionTitle } from "sweet-web/components/universal/Text";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { SendMobileInvite } from "sweet-web/redux/user/actions";
import { ActivateVenue, UpdateVenue } from "sweet-web/redux/venue/actions";

const Download = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Finalize: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue, phoneNumber } = props;

  const [phone, setPhone] = useState(phoneNumber);
  const [agreed, setAgreed] = useState(false);
  const [phoneInvite, setPhoneInvite] = useState(
    false as false | "inviting" | true
  );

  const back = async () => {
    props.history.push(`/listing/${venueId}/payment`);
  };

  const followLink = (link: string) => {
    const win = window.open(link, "_blank");
    win.focus();
  };

  const onFinalize = async () => {
    if (!phoneInvite) {
      alert("Get the mobile app before activating your listing");

      return;
    }
    if (!agreed) {
      alert(
        "You must agree to the Sweet Terms of Use and Privacy Policy before activating your listing"
      );

      return;
    }
    const validation = validateVenue(venue);
    if (!validation.valid) {
      alert(`Please fix the following: ${validation.errors.join(", ")}`);

      return;
    }
    const activated = await props.ActivateVenue(venueId);
    if (activated) {
      props.history.push(`/listing/${venueId}/activated`);
    } else {
      alert(
        "An error occurred. Our team has been notified and we will get back to you shortly"
      );
    }
  };

  const onMobileInviteClick = async () => {
    setPhoneInvite("inviting");
    const invited = await props.SendMobileInvite(phone);
    if (invited) setPhoneInvite(true);
    else setPhoneInvite(false);
  };

  const onPoliciesAccept = newAgreed => {
    if (newAgreed) {
      props.UpdateVenue(venueId, {
        agreedTime: moment().unix()
      });
    }
    setAgreed(newAgreed);
  };

  return (
    <Wrapper>
      <Section>
        <SectionTitle style={{ marginBottom: 0 }}>
          Download Sweet Mobile App
        </SectionTitle>
        <Label>Respond to inquiries and convert bookings from your phone</Label>
        <Download>
          <PhoneNumberInput
            title={null}
            value={phone}
            onChange={value => {
              setPhone(value);
            }}
          />
          <OutlineButton
            style={{ marginLeft: 10 }}
            color={phoneInvite == true ? "dark" : null}
            title={
              phoneInvite == true
                ? "You'll Get Early Access"
                : phoneInvite == "inviting"
                ? "Joining Waitlist..."
                : "Get Early Access"
            }
            disabled={phoneInvite != false}
            onClick={onMobileInviteClick}
          />
        </Download>
      </Section>
      <Section>
        <SectionTitle style={{ marginBottom: 0 }}>
          Review Sweet Policies
        </SectionTitle>
        <Label>
          Sweet charges a 10% booking fee in addition to the event price
        </Label>
        <Buttons>
          <OutlineButton
            title="Terms of Use"
            color="dark"
            onClick={() => followLink("/terms")}
          />
          <OutlineButton
            color="dark"
            style={{ marginLeft: 10 }}
            title="Privacy Policy"
            onClick={() => followLink("/privacy")}
          />
        </Buttons>
        <CheckboxInput
          style={{ marginTop: 10 }}
          title="I reviewed and accept the Terms of Use and Privacy Policy"
          value={agreed}
          onChange={onPoliciesAccept}
        />
      </Section>
      <Section>
        <SectionTitle style={{ marginBottom: 0 }}>
          Activate Your Listing
        </SectionTitle>
        <Label>Make your venue public on Sweet</Label>
        <OutlineButton
          style={{ marginTop: 10 }}
          title="Start Receiving Bookings"
          onClick={onFinalize}
        />
      </Section>
      <BackButton onClick={back} />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state),
    phoneNumber: selectors.userPhoneNumber(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      UpdateVenue,
      ActivateVenue,
      SendMobileInvite
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Finalize);
